import { ReportType } from 'app/dataTypes/reports'

export const apiStringFromReportType = (reportType: ReportType): string => {
  if (reportType === ReportType.Corrections) return 'corrections'
  if (reportType === ReportType.SubsidiesGrouped) return 'subsidies_grouped'
  if (reportType === ReportType.SubsidiesAct) return 'subsidies_act'
  if (reportType === ReportType.SubsidiesDetailed) return 'subsidies_detailed'
  if (reportType === ReportType.OrdersByClasses) return 'goverment_cafeteria_orders_by_classes'
  if (reportType === ReportType.FinancesSummary) return 'finances_summary'
  if (reportType === ReportType.FinancesSummaryReplenishment) return 'finances_payments'
  if (reportType === ReportType.FinancesSummaryWriteOff) return 'finances_write_offs'
  if (reportType === ReportType.AverageCheck) return 'average_check'
  // TODO все отчеты
  const exhaustiveCheck: never = reportType
  return exhaustiveCheck
}
